import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import router from './router';
import axios from 'axios';
import store from '@/store';
import '@/assets/css/reset.less';
import '@/assets/css/common.less';
import '@/assets/css/screen.less';

Vue.use(ElementUI);
// eslint-disable-next-line no-undef
Vue.prototype.$axios = axios;

// 全局Mixin
import Mixin from './mixins/public-mixin';
Vue.mixin(Mixin);

// 全局filter
import filters from '@/filters/index';
for (let key in filters) {
  Vue.filter(key, filters[key]);
}

import utilFuncs from './utils/utils';
window.$utils = Vue.prototype.$utils = utilFuncs;

// 定义全局API路径
import conf from '@/config';
window.config = Vue.prototype.$config = conf;

new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App),
});
